<template>
  <v-layout row wrap class="mb-3" v-if="Object.keys(activeFilters).length > 0">
    <v-flex xs12>
      <div class="active-filters-container" role="region" aria-label="Active filters">
        <div class="active-filters-title">
          <v-icon small color="primary" class="mr-1" aria-hidden="true">mdi-filter</v-icon>
          <span>{{ $i18n.t("Active Filters") }}:</span>
        </div>
        <div class="active-filters-scroll" role="list">
          <v-chip
            v-for="(value, key) in activeFilters"
            :key="key"
            close
            class="ma-1 filter-chip"
            color="primary"
            text-color="white"
            @input="$emit('remove-filter', key)"
            role="listitem"
            :aria-label="`Remove filter ${key}: ${value}`"
          >
            <div class="filter-content">
              <strong class="filter-key">{{ key }}</strong>
              <span class="filter-value">{{ value }}</span>
            </div>
          </v-chip>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "ActiveFilters",
  props: {
    activeFilters: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.active-filters-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 8px 16px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 16px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.active-filters-title {
  font-weight: 500;
  margin-right: 8px;
  display: flex;
  align-items: center;
  color: #000000;
}

.active-filters-scroll {
  display: flex;
  flex-wrap: wrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  scrollbar-width: thin;
}

.filter-chip {
  margin: 4px;
  font-size: 12px;
  height: auto !important;
  min-height: 28px;
}

.filter-chip::v-deep .v-chip__content {
  white-space: normal;
  height: auto;
  flex-wrap: wrap;
  padding: 4px 8px;
}

.filter-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 100%;
}

.filter-key {
  margin-right: 4px;
}

.filter-value {
  word-break: break-word;
  line-height: 1.2;
}

.filter-chip::v-deep .v-chip__close {
  opacity: 1;

  color: white;
  margin-top: 4px;
}

.filter-chip::v-deep:focus {
  outline: 2px solid white;
  outline-offset: 2px;
}

.active-filters-scroll::-webkit-scrollbar {
  display: none;
}

.active-filters-scroll {
  -ms-overflow-style: none;

  scrollbar-width: none;
}
</style>
